import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import BsButton from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import ViewResultButton from '../../../molecules/screener/view-result-button';

import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import styles from './filters-footer.module.scss';
import Icon from '../../../atoms/icon';
import ResetFiltersLink from '../../../molecules/screener/reset-filters-link';

const className = augmentClassName(styles);

const FiltersFooter = ({ collapsePresetCategory, viewResult }) => {
  return (
    <div {...className('py-6', 'root')}>
      <Container>
        <Row {...className('align-items-center')}>
          <Col>
            <ResetFiltersLink />
          </Col>
          <Col {...className('col-6', 'd-flex', 'justify-content-center')}>
            <BsButton
              {...className('custom-filters')}
              onClick={collapsePresetCategory}
              // TIAA Analytics Tracking
              id="InvestmentScreenerCustomFilters"
              data-analytics-linkname="Custom_filters"
              data-analytics-section="component"
              data-analytics-componenttype="JumpNav"
            // END TIAA Analytics Tracking
            >Custom filters
              <Icon.ChevronUp {...className('px-2')} height="20px" width="20px" strokeWidth="2" />
            </BsButton>
          </Col>
          <Col {...className('text-right')}>
            <ViewResultButton viewResult={viewResult} collapsePresetCategory={collapsePresetCategory} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

FiltersFooter.propTypes = {
  viewResult: PropTypes.func,
  collapsePresetCategory: PropTypes.func
};

export default FiltersFooter;
